import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';
import Navbar from '../components/Navbar';

const ProtectedRoute = () => {
  const {isLogged, loading} = useContext(AuthContext);

  if (loading) {
      return <div>Loading...</div>; // or your loading component
  }

  if (isLogged()) {
    return (<>
      <Navbar />
      <Outlet />
    </>);
  }else{
    return <Navigate to="/" />;
  }
};

export default ProtectedRoute;